var _defs, _polyline, _line, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCantGrosWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a72b9f7b-b6cb-4be7-93e4-c58cbd05b798",
    "data-name": "cant_gros",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.78 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ad02ba8c-842e-4246-aa67-043f2f9aa8f9,.ff5b4463-3e02-470c-88d5-779ae8d982d3{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.ff5b4463-3e02-470c-88d5-779ae8d982d3{stroke-width:10px;}.ad02ba8c-842e-4246-aa67-043f2f9aa8f9{stroke-width:5px;}.f0a8ffa6-ea49-4ba7-9993-94e5a4b6af6a{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cant_gros_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "ff5b4463-3e02-470c-88d5-779ae8d982d3",
    points: "5 50 139 50 139 5 5 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ff5b4463-3e02-470c-88d5-779ae8d982d3",
    x1: 129.53,
    y1: 5.5,
    x2: 129.53,
    y2: 49.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b62bc454-5475-4793-ab07-7d470098f831",
    "data-name": "Arrow copy 5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ad02ba8c-842e-4246-aa67-043f2f9aa8f9",
    x1: 71.72,
    y1: 27.5,
    x2: 119.08,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "f0a8ffa6-ea49-4ba7-9993-94e5a4b6af6a",
    d: "M96.16,116.8a1.76,1.76,0,0,1,.53-2.42L119.28,100,96.69,85.62a1.75,1.75,0,0,1,1.88-3l24.9,15.86a1.76,1.76,0,0,1,0,3l-24.9,15.86a1.75,1.75,0,0,1-2.41-.54Z",
    transform: "translate(-1 -72.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad02ba8c-842e-4246-aa67-043f2f9aa8f9",
    x1: 196.28,
    y1: 27.5,
    x2: 148.92,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "f0a8ffa6-ea49-4ba7-9993-94e5a4b6af6a",
    d: "M173.84,83.2a1.76,1.76,0,0,1-.53,2.42L150.72,100l22.59,14.38a1.75,1.75,0,0,1-1.88,3l-24.9-15.86a1.76,1.76,0,0,1,0-3l24.9-15.86a1.75,1.75,0,0,1,2.41.54Z",
    transform: "translate(-1 -72.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCantGrosWhite);
export default __webpack_public_path__ + "static/media/cant_gros_white.6e7bd088e0223d1ee6b88170f28f6ab0.svg";
export { ForwardRef as ReactComponent };